import React from "react";

import { QuickAddProps } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/QuickAdd/QuickAddProps";
import { QuickAddTrackingEventsContext } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/QuickAdd/QuickAddTrackingEventsContext/QuickAddTrackingEventsContext";
import { useGetProductTileClickImpressions } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/productTileActions/useGetProductTileClickImpressions";

export interface IQuickAddEventParams {
  productToken?: string;
  newQuantity?: number;
}

interface IQuickAddTrackingEventsProvider {
  onQuickAddButtonClick?: (data: IQuickAddEventParams) => void;
  onQuickAddSubmit?: (data: IQuickAddEventParams) => void;
  onChooseOptionClick?: (data: IQuickAddEventParams) => void;
  onChooseOptionQuantityUpdateSubmit?: (data: IQuickAddEventParams) => void;
}

export const QuickAddTrackingEventsContextBaseProvider: React.FC<
  React.PropsWithChildren<
    { data: QuickAddProps } & IQuickAddTrackingEventsProvider
  >
> = ({ data, children, ...events }) => {
  const {
    onQuickAddButtonClick: customOnQuickAddButtonClickEvent,
    onQuickAddSubmit: customOnQuickAddSubmitEvent,
    onChooseOptionClick: customOnChooseOptionClickEvent,
    onChooseOptionQuantityUpdateSubmit:
      customOnChooseOptionQuantityUpdateSubmitEvent,
  } = events;

  const {
    recordQuickAddSubmitEvent,
    recordQuickAddButtonClickEvent,
    recordChooseOptionClickEvent,
    recordChooseOptionQuantityUpdateSubmitEvent,
  } = useGetProductTileClickImpressions({
    token: data.productToken,
    impressionId: data.impressionId,
    promotedBy: data.promotedBy,
  });

  const onQuickAddButtonClick = (newQuantity?: number) => {
    customOnQuickAddButtonClickEvent?.({
      productToken: data.productToken,
      newQuantity,
    });
    recordQuickAddButtonClickEvent();
  };
  const onQuickAddSubmit = (newQuantity?: number) => {
    customOnQuickAddSubmitEvent?.({
      productToken: data.productToken,
      newQuantity,
    });
    recordQuickAddSubmitEvent(newQuantity);
  };

  const onChooseOptionClick = () => {
    customOnChooseOptionClickEvent?.({
      productToken: data.productToken,
    });
    recordChooseOptionClickEvent();
  };

  const onChooseOptionQuantityUpdateSubmit = (newQuantity?: number) => {
    customOnChooseOptionQuantityUpdateSubmitEvent?.({
      productToken: data.productToken,
      newQuantity,
    });
    recordChooseOptionQuantityUpdateSubmitEvent(newQuantity);
  };

  return (
    <QuickAddTrackingEventsContext.Provider
      value={{
        onQuickAddButtonClick,
        onQuickAddSubmit,
        onChooseOptionClick,
        onChooseOptionQuantityUpdateSubmit,
      }}
    >
      {children}
    </QuickAddTrackingEventsContext.Provider>
  );
};
